import { render, staticRenderFns } from "./document_list.vue?vue&type=template&id=12de58f4&scoped=true&"
import script from "./document_list.vue?vue&type=script&lang=js&"
export * from "./document_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12de58f4",
  null
  
)

export default component.exports